import { render, staticRenderFns } from "./selecionar-produto.vue?vue&type=template&id=067e260d&"
import script from "./selecionar-produto.vue?vue&type=script&lang=js&"
export * from "./selecionar-produto.vue?vue&type=script&lang=js&"
import style0 from "./selecionar-produto.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports